import { curry } from "ramda";
import { nil } from "../../../../types";

function selectByEnum_core<T extends { [k in string | number]?: any;}>(selection: T, input: any): T[keyof T] | undefined {
	return selection[input] || selection.default;
}

const selectByEnum = curry(selectByEnum_core);
export default selectByEnum as typeof selectByEnum & typeof selectByEnum_core;